import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "col bg-light p-4"
};
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-4" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-4 g-4 mb-5" };
const _hoisted_6 = { class: "card border-0 shadow-sm h-100 stats-card" };
const _hoisted_7 = { class: "card-body" };
const _hoisted_8 = { class: "d-flex align-items-center" };
const _hoisted_9 = { class: "text-muted mb-0 small text-uppercase fw-bold" };
const _hoisted_10 = { class: "mb-0 fw-bold" };
const _hoisted_11 = { class: "row g-4 mb-5" };
const _hoisted_12 = { class: "col-xl-8" };
const _hoisted_13 = { class: "card border-0 shadow-sm" };
const _hoisted_14 = { class: "card-body" };
const _hoisted_15 = { class: "col-xl-4" };
const _hoisted_16 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_17 = { class: "card-body" };
const _hoisted_18 = {
    key: 0,
    class: "list-group list-group-flush"
};
const _hoisted_19 = { class: "d-flex align-items-center" };
const _hoisted_20 = { class: "badge bg-light text-dark me-2" };
const _hoisted_21 = { class: "text-dark" };
const _hoisted_22 = { class: "badge bg-success rounded-pill" };
const _hoisted_23 = {
    key: 1,
    class: "text-center py-5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_apexchart = _resolveComponent("apexchart");
    return (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoaderComponent)
        ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "fw-bold text-dark m-0" }, "Marketing Analytics", -1)),
                _createElementVNode("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "me-2 text-muted" }, "Période :", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedDays) = $event)),
                        onChange: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchData && _ctx.fetchData(...args)))
                    }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("option", { value: 7 }, "7 derniers jours", -1),
                            _createElementVNode("option", { value: 30 }, "30 derniers jours", -1),
                            _createElementVNode("option", { value: 90 }, "90 derniers jours", -1)
                        ]))], 544), [
                        [_vModelSelect, _ctx.selectedDays]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpis, (kpi) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "col",
                        key: kpi.label
                    }, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(['icon-box rounded-circle me-3', kpi.bgClass])
                                    }, [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(['fa', kpi.icon])
                                        }, null, 2)
                                    ], 2),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_9, _toDisplayString(kpi.label), 1),
                                        _createElementVNode("h4", _hoisted_10, _toDisplayString(kpi.value), 1)
                                    ])
                                ])
                            ])
                        ])
                    ]));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header bg-white border-0 pt-4 px-4" }, [
                            _createElementVNode("h5", { class: "card-title fw-bold m-0" }, "Sessions vs Commandes")
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_apexchart, {
                                type: "line",
                                height: "350",
                                options: _ctx.chartOptions,
                                series: _ctx.chartSeries
                            }, null, 8, ["options", "series"])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header bg-white border-0 pt-4 px-4" }, [
                            _createElementVNode("h5", { class: "card-title fw-bold m-0" }, "Top Produits (Ajouts panier)")
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, [
                            (_ctx.stats.topProducts && _ctx.stats.topProducts.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.topProducts, (product, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "list-group-item d-flex justify-content-between align-items-center px-0"
                                        }, [
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1), 1),
                                                _createElementVNode("span", _hoisted_21, _toDisplayString(product.name), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(product.adds) + " clics", 1)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("p", { class: "text-muted" }, "Aucune donnée disponible", -1)
                                    ]))]))
                        ])
                    ])
                ])
            ])
        ]));
}
